module.exports = __webpack_public_path__ + "assets/img/interesting-games.9729d658.png";